/** Supported deposit frequencies for deposits */
export enum DepositFrequencies {
    once = 'Once',
    weekly = 'Weekly',
    monthly = 'Monthly'
}
